export class Sharetribe {
  constructor(clientId, clientSecret, sdk) {
    this.clientId = clientId
    this.clientSecret = clientSecret
    this.sharetribeSdk = sdk
  }

  createInstance(token) {
    const clientId = this.clientId
    const clientSecret = this.clientSecret

    return this.sharetribeSdk.createInstance({
      clientId,
      clientSecret,
      ...(token && { tokenStore: this.memoryStore(token) }),
    })
  }

  memoryStore(token) {
    const store = this.sharetribeSdk.tokenStore.memoryStore()
    store.setToken(token)

    return store
  }
}
